export default function ArrowRollbackIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={'flex items-center ' + className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 14 14'
        fill='currentColor'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M6.06015 5.49573C6.27711 5.71268 6.27711 6.06444 6.06015 6.2814L3.67521 8.66634L6.06015 11.0513C6.27711 11.2682 6.27711 11.62 6.06015 11.837C5.8432 12.0539 5.49144 12.0539 5.27448 11.837L2.4967 9.05918C2.27974 8.84222 2.27974 8.49046 2.4967 8.2735L5.27448 5.49573C5.49144 5.27877 5.8432 5.27877 6.06015 5.49573Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.7784 2C12.0853 2 12.334 2.24873 12.334 2.55556V6.44444C12.334 7.18116 12.0413 7.8877 11.5204 8.40863C10.9995 8.92956 10.2929 9.22222 9.55621 9.22222H2.88954C2.58272 9.22222 2.33398 8.97349 2.33398 8.66667C2.33398 8.35984 2.58272 8.11111 2.88954 8.11111H9.55621C9.99823 8.11111 10.4222 7.93552 10.7347 7.62296C11.0473 7.31039 11.2229 6.88647 11.2229 6.44444V2.55556C11.2229 2.24873 11.4716 2 11.7784 2Z'
        />
      </svg>
    </span>
  );
}
